/**
 * Generated bundle index. Do not edit.
 */

export * from './json_api';

export {JsonAPISerializerOptions as ɵa} from './lib/json-api/jsonapi-serilizer-option';